import { render, staticRenderFns } from "./member_list.vue?vue&type=template&id=52751675&scoped=true&"
import script from "./member_list.vue?vue&type=script&lang=js&"
export * from "./member_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52751675",
  null
  
)

export default component.exports